module.exports = __webpack_public_path__ + "img/team_img.c6da982f.png";